export interface IApplication {
  [key: string]: boolean;
}

export interface ITenantApplication {
  id: string;
  name: string;
  wholesale: boolean;
  retail: boolean;
}

/**
 * Object containing all session information:
 * * username
 * * userId
 * * email
 * * tenantId
 * * wholesale
 * * retail
 * * roles
 * * fullname
 * * tz
 * * sid - session id, read from the cookie
 * * language
 * * isLogged
 * * availableTenants - array of available ids
 * * applications - object in a format { <application-name>: true|false}
 * * deviceId
 * * warehouse
 * * type
 * * acls
 * * reportAcls
 * * favorites
 * * email_verify_pending
 */
export class SessionObject {
  public username: string;
  public userId: string;
  public email: string;
  public tenantId: string;
  public wholesale: boolean;
  public retail: boolean;
  public roles: object;
  public fullname: string;
  public tz: string;
  public sid: string;
  public language: string;
  public isLogged: boolean;
  public availableTenants: ITenantApplication[];
  public applications: IApplication;
  public deviceId: string;
  public warehouse: string;
  public type: string;
  public acls: object;
  public reportAcls: object;
  public favorites: object;
  public email_verify_pending: boolean;
  public countryCode: string;
}

// Hack! It makes sure that in the test scripts & test are using the same
// reference to the class
export const SessionObjectProvider = {
  provide: 'SessionObject',
  useValue: SessionObject,
};
